var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('d-container',[_c('d-header',[_c('h1',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('account_parameters'))+"\n      ")])])],1),_vm._v(" "),_c('v-form-info',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('v-form-password',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }